/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

const apiGet = async (url, apiOptions = {}, apiHeaders = {}, errorHandler) => {
  const defaultOptions = {
    credentials: 'include',
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  };

  const {headers} = defaultOptions;
  defaultOptions.headers = {...headers, ...apiHeaders};
  const options = {...defaultOptions, ...apiOptions};

  try {
    const response = await fetch(url, options);
    const contentType = response.headers && response.headers.get ? response.headers.get('content-type') : undefined;
    const isJson = contentType && contentType.toLowerCase().includes('application/json');

    if (response.ok) {
      const data = isJson ? await response.json() : await response.text();
      return data;
    }

    const errorPayload = isJson ? await response.json() : await response.text();
    const errorObj = {
      status: response.status,
      statusText: response.statusText,
      url: response.url,
      data: errorPayload
    };
    if (errorHandler) errorHandler(errorObj);
    return Promise.reject(errorObj);
  } catch (err) {
    return Promise.reject(err);
  }
};

const apiPost = async (url, body, apiHeaders = {}) => {
  let responseCode, correlationId;

  const postRequest = {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'content-type': 'application/json',
    },
    body: JSON.stringify(body),
  };

  postRequest.headers = {...postRequest.headers, ...apiHeaders};

  try {
    const response = await fetch(url, postRequest);
    const rawCorrelation = response.headers && response.headers.get ? response.headers.get('x-jpm-correlation-id') : undefined;
    correlationId = rawCorrelation == null ? undefined : rawCorrelation;
    responseCode = response.status;
    const contentType = response.headers && response.headers.get ? response.headers.get('content-type') : undefined;
    const isJson = contentType && contentType.toLowerCase().includes('application/json');

    if (response.ok) {
      const payload = isJson ? await response.json() : await response.text();
      return { data: payload, status: responseCode, correlationId };
    }

    const errorPayload = isJson ? await response.json() : await response.text();
    const err = Object.assign(new Error('POST failed'), { status: responseCode, correlationId, data: errorPayload });
    return Promise.reject(err);
  } catch (err) {
    return Promise.reject(err);
  }
};

export {apiGet, apiPost};
